module.exports = __webpack_public_path__ + "823faf00ec19e060a8142e8efc4bff44.jpg";